import { Link } from 'react-router-dom';
import type { Film } from '@/types/film';
import { typeLabel } from '@/mocks/categories';
import { viewCountLabel } from '@/lib/catalog';

interface TrendListProps {
  films: Film[];
}

export default function TrendList({ films }: TrendListProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-200 bg-background-100">
        <span className="text-xs font-semibold text-foreground-700 flex items-center gap-1.5">
          <i className="ri-fire-line text-accent-600" />
          热播榜 · 实时热度
        </span>
        <span className="text-[10px] text-foreground-400">演示数据</span>
      </div>
      <ul>
        {films.map((film, index) => (
          <li key={film.id}>
            <Link to={`/detail/${film.id}`} className="group flex items-center gap-3 px-4 py-3 hover:bg-background-100 transition-colors">
              <span
                className={`w-5 text-center text-sm font-bold shrink-0 ${
                  index < 3 ? 'text-accent-600' : 'text-foreground-400'
                }`}
              >
                {index + 1}
              </span>
              <span className="w-10 h-14 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={film.poster}
                  alt={`${film.title} 封面`}
                  title={`${film.title} ${film.genre}`}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {film.title}
                </span>
                <span className="mt-1 block text-[11px] text-foreground-500 truncate">
                  {typeLabel(film.type)} · {film.genre} · {film.year}
                </span>
                <span className="mt-0.5 block text-[11px] text-foreground-400 truncate">{viewCountLabel(film.views)}</span>
              </span>
              <i className="ri-arrow-right-s-line text-foreground-300 shrink-0 group-hover:text-accent-600 transition-colors" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}